const SIZES = { nano: "nano", small: "small" };

const DROPDOWN_BUTTON_SIZES = { nano: "small", small: "medium" };

export { SIZES, DROPDOWN_BUTTON_SIZES };
